<template>
  <div v-if="contents.length > 0" class="live live02">
    <div class="inner">
      <Title>
        <template #title>
          学び・遊び・体験LIVE
        </template>
      </Title>
      <div class="description">
        <p>
          ママ主催者による楽しい「学び・体験・遊びLIVE」ひとりで、親子で、気軽に参加しよう♪
        </p>
      </div>
      <div class="live-programs">
        <LiveProgram10kantou
          v-for="(program, key) in contents"
          :key="program.id + key + 'provider'"
          :program="program"
          liveType="provider"
          :month="month"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Title from '@/components/atoms/Title.vue'
import LiveProgram10kantou from '@/components/molecules/202010kantou/LiveProgram.vue'
export default {
  props: {
    month: {
      type: String,
      required: true
    },
    contents: {}
  },
  components: {
    Title,
    LiveProgram10kantou
  }
}
</script>

<style lang="sass" scoped>
.live02
  padding: 25px 0
</style>
